import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { numberToCurrency } from 'lib/money'
import {
  ELECTRONIC_GIFT_CARD_MIN,
  ELECTRONIC_GIFT_CARD_MAX,
} from 'shared/constants'

const PriceDisplay = ({
  isElectronicGiftCard,
  isFavor,
  price,
  priceClassName,
  msrpClassName,
  truncateZeroCents,
}) => {
  let showMsrp = false
  const options = { truncateZeroCents }

  // eslint-disable-next-line complexity
  const priceString = () => {
    if (isElectronicGiftCard) {
      return `$${ELECTRONIC_GIFT_CARD_MIN} - $${ELECTRONIC_GIFT_CARD_MAX}`
    }

    if (price && !isFavor) {
      const min = price.min || price.current
      const max = price.max || price.current
      showMsrp = min === max && price.msrp && price.msrp > max

      return min === max
        ? numberToCurrency(min, options)
        : `${numberToCurrency(min, options)} - ${numberToCurrency(
            max,
            options
          )}`
    }
    return null
  }

  const displayPrice = priceString()
  const msrpDisplayPrice = showMsrp
    ? numberToCurrency(price.msrp, options)
    : null

  return (
    <>
      <span
        aria-label={
          showMsrp ? `Sale Price: ${displayPrice},` : `Price: ${displayPrice}`
        }
        itemProp="price"
        className={classNames('text-bold', priceClassName)}
      >
        {displayPrice}
      </span>
      {showMsrp ? (
        <s
          aria-label={`Regular Price: ${msrpDisplayPrice}`}
          className={classNames('text-muted', msrpClassName, {
            mls: !msrpClassName,
          })}
        >
          {msrpDisplayPrice}
        </s>
      ) : null}
    </>
  )
}

PriceDisplay.propTypes = {
  isElectronicGiftCard: PropTypes.bool,
  isFavor: PropTypes.bool,
  price: PropTypes.shape({
    min: PropTypes.number,
    max: PropTypes.number,
    current: PropTypes.number,
    msrp: PropTypes.number,
  }).isRequired,
  priceClassName: PropTypes.string,
  msrpClassName: PropTypes.string,
  truncateZeroCents: PropTypes.bool,
}

PriceDisplay.defaultProps = {
  priceClassName: '',
  msrpClassName: '',
  isElectronicGiftCard: false,
  isFavor: false,
  truncateZeroCents: false,
}

export default PriceDisplay
